export default __webpack_public_path__ + "static/media/check.5a7a3eac.svg";